var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 0.710449H2.2168C1.05369 0.710449 0.107422 1.65671 0.107422 2.81982V8.06982C0.107422 9.23293 1.05369 10.1792 2.2168 10.1792H15.998C17.1612 10.1792 18.1074 9.23293 18.1074 8.06982V2.81982C18.1074 1.65671 17.1612 0.710449 15.998 0.710449ZM16.7012 8.06982C16.7012 8.45753 16.3857 8.77295 15.998 8.77295H2.2168C1.82909 8.77295 1.51367 8.45753 1.51367 8.06982V2.81982C1.51367 2.43212 1.82909 2.1167 2.2168 2.1167H15.998C16.3857 2.1167 16.7012 2.43212 16.7012 2.81982V8.06982Z",
    fill: "#677C95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1162 6.97067C12.8416 7.24526 12.3965 7.24525 12.1219 6.97067L10.3954 5.24421L10.3558 5.20463C10.0812 4.93004 10.0812 4.48485 10.3558 4.21026C10.6304 3.93567 11.0756 3.93567 11.3502 4.21026L11.3898 4.24984L12.6195 5.47957L13.8492 4.24984L13.8888 4.21023C14.1634 3.93568 14.6086 3.93573 14.883 4.21035C15.1575 4.4849 15.1574 4.92991 14.8829 5.20437L14.843 5.24421L13.1162 6.97067Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.4d9f08e9c4a51b814a9f0a251062de04.svg";
export { ForwardRef as ReactComponent };